/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_ITEM (state, item) {
    state.products.unshift(item)
  },
  SET_PRODUCTS (state, products) {
    state.products = products
  },
  // SET_LABELS(state, labels) {
  //   state.eventLabels = labels
  // },
  UPDATE_PRODUCT (state, product) {
    const productIndex = state.products.findIndex((p) => p.id === product.id)
    Object.assign(state.products[productIndex], product)
  },
  REMOVE_ITEM (state, itemId) {
    const ItemIndex = state.products.findIndex((p) => p.id === itemId)
    state.products.splice(ItemIndex, 1)
  },


  ADD_STUDENT (state, item) {
    state.students.unshift(item)
  },
  SET_STUDENTS (state, students) {
    state.students = students
  },
  UPDATE_STUDENT (state, student) {
    const Index = state.students.findIndex((p) => p.id === student.id)
    Object.assign(state.students[Index], student)
  },
  REMOVE_STUDENT (state, StudentId) {
    const Index = state.students.findIndex((p) => p.id === StudentId)
    state.students.splice(Index, 1)
  },

  //CAM USERS
  ADD_CAMUSER (state, item) {
    state.cam_users.unshift(item)
  },
  SET_CAMUSERS (state, cam_users) {
    state.cam_users = cam_users
  },
  UPDATE_CAMUSER (state, cam_user) {
    const Index = state.cam_users.findIndex((p) => p.id === cam_user.id)
    Object.assign(state.cam_users[Index], cam_user)
  },
  REMOVE_CAMUSER (state, CamUserId) {
    const Index = state.cam_users.findIndex((p) => p.id === CamUserId)
    state.cam_users.splice(Index, 1)
  },


  //ADD LOCATION
  ADD_LOCATION (state, item) {
    state.locations.unshift(item)
  },
  SET_LOCATION (state, locations) {
    state.locations = locations
  },
  UPDATE_LOCATION (state, locations) {
    const Index = state.locations.findIndex((p) => p.id === locations.id)
    Object.assign(state.locations[Index], locations)
  },
  REMOVE_LOCATION (state, Id) {
    const Index = state.locations.findIndex((p) => p.id === Id)
    state.locations.splice(Index, 1)
  },
  //ADD PROGRAM
  ADD_PROGRAM (state, item) {
    state.programs.unshift(item)
  },
  SET_PROGRAM (state, programs) {
    state.programs = programs
  },
  UPDATE_PROGRAM (state, programs) {
    const Index = state.programs.findIndex((p) => p.id === programs.id)
    Object.assign(state.programs[Index], programs)
  },
  REMOVE_PROGRAM (state, Id) {
    const Index = state.programs.findIndex((p) => p.id === Id)
    state.programs.splice(Index, 1)
  },

  //ADD PROGRAM
  ADD_MANAGER (state, item) {
    state.managers.unshift(item)
  },
  SET_MANAGER (state, managers) {
    state.managers = managers
  },
  UPDATE_MANAGER (state, managers) {
    const Index = state.managers.findIndex((p) => p.id === managers.id)
    Object.assign(state.managers[Index], managers)
  },
  REMOVE_MANAGER (state, Id) {
    const Index = state.managers.findIndex((p) => p.id === Id)
    state.managers.splice(Index, 1)
  },


  //ADD LOCATION
  ADD_SCHEDULE (state, item) {
    state.schedules.unshift(item)
  },
  SET_SCHEDULE (state, schedules) {
    state.schedules = schedules
  },
  UPDATE_SCHEDULE (state, schedules) {
    const Index = state.schedules.findIndex((p) => p.id === schedules.id)
    Object.assign(state.schedules[Index], schedules)
  },
  REMOVE_SCHEDULE (state, Id) {
    const Index = state.schedules.findIndex((p) => p.id === Id)
    state.schedules.splice(Index, 1)
  },

  //ADD CAMERAS
  ADD_CAMERA (state, item) {
    state.cameras.unshift(item)
  },
  SET_CAMERA (state, cameras) {
    state.cameras = cameras
  },
  UPDATE_CAMERA (state, cameras) {
    const Index = state.cameras.findIndex((p) => p.id === cameras.id)
    Object.assign(state.cameras[Index], cameras)
  },
  REMOVE_CAMERA (state, Id) {
    const Index = state.cameras.findIndex((p) => p.id === Id)
    state.cameras.splice(Index, 1)
  }
}
